<ca-notification-list-toolbar
  (markAllAsReadClick)="list.markAllAsRead()"
  (filterChange)="list.loadWithStatus($event.status)"
></ca-notification-list-toolbar>
<div class="row split-panel-container full-height">
  <as-split
    [unit]="splitConfig.unit"
    [direction]="splitConfig.direction"
    [useTransition]="splitConfig.useTransition"
    [gutterSize]="splitConfig.gutterSize"
    (dragEnd)="onDragEnd($event)"
    #split="asSplit"
  >
    <as-split-area
      [size]="(layout$ | async)?.config.center.size"
      [minSize]="(layout$ | async).config.center.minSize"
      [maxSize]="(layout$ | async).config.center.maxSize"
      [visible]="(layout$ | async).config.center.visible"
      [order]="1"
      class="center-panel"
    >
      <ca-notification-list #list></ca-notification-list>
    </as-split-area>
    <as-split-area
      [size]="(layout$ | async)?.config.east.size"
      [minSize]="(layout$ | async).config.east.minSize"
      [maxSize]="(layout$ | async).config.east.maxSize"
      [visible]="(layout$ | async).config.east.visible"
      [order]="2"
      style="display: flex; flex-direction: column; justify-content: stretch; align-items: stretch"
    >
    </as-split-area>
  </as-split>
</div>
